import { render, staticRenderFns } from "./LiveMain.vue?vue&type=template&id=0717fa1c&scoped=true&"
import script from "./LiveMain.vue?vue&type=script&lang=js&"
export * from "./LiveMain.vue?vue&type=script&lang=js&"
import style0 from "./LiveMain.vue?vue&type=style&index=0&id=0717fa1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0717fa1c",
  null
  
)

export default component.exports